module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAMAAACf4xmcAAAALVBMVEXHx8fNzc3CwsLCwsLNzc3Hx8fNzc3Nzc2/v7/Nzc3Nzc3Nzc0AAADKysrNzc2HVd2uAAAADXRSTlO9beTjbryRE/4oBEgAhJ1L4AAAAItJREFUeNrNlFsKwzAMBNP6GavZ+x83JsQsQWAZBCXzPWC8Wmn7LfEWTWRFayG0Be0DRFsrFajF1DI62dL2A51jN7SEizTXBDcy09p3aKFNtAgMotYYBrVatMYwSFYawxgwFK1teJD+0Df9qOMLOhBvvHpY9uj9RWItPSXXK+NfQK6z+zgQkfeeQUJO94BDryz8bqsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/assets/img/jquery.datatables/sort_both@2x.png
// module id = ../../../../../src/assets/img/jquery.datatables/sort_both@2x.png
// module chunks = 2